import React, { useEffect, useState } from "react";
import { ActivityIcon as Function, AlignLeft, CodeXml, Database } from "lucide-react";
import { teacherAPI } from "../../../api/aulasApi";
import "./CardClass.css";

const subjectIcons = {
  "Cálculo I": <Function className="icon" size={20} />,
  "Programação I": <CodeXml className="icon" size={20} />,
  "Banco de Dados": <Database className="icon" size={20} />,
  "Estrutura de Dados": <Database className="icon" size={20} />,
};

const subjectTimes = {
  "Cálculo I": "08:00 - 10:00",
  "Programação I": "10:00 - 12:00",
  "Banco de Dados": "14:00 - 16:00",
  "Estrutura de Dados": "16:00 - 18:00",
  "Inglês Instrumental": "08:00 - 10:00",
};

function ClassSchedule() {
  const [scheduleItems, setScheduleItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await teacherAPI.getMyClasses();
        const formattedItems = response.data.map(item => ({
          date: item.dia,
          room: `Sala ${item.sala}`,
          subject: item.materia,
          icon: subjectIcons[item.materia] || <AlignLeft className="icon" size={20} />,
          time: subjectTimes[item.materia] || "Horário não definido"
        }));
        setScheduleItems(formattedItems);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchClasses();
  }, []);

  if (loading) return <div className="schedule-wrapper">Carregando...</div>;
  if (error) return <div className="schedule-wrapper">Erro: {error}</div>;

  return (
    <div className="schedule-wrapper">
      <div className="schedule-scroll-container">
        <div className="schedule-items-container">
          {scheduleItems.map((item, index) => (
            <div key={index} className="schedule-card">
              <div className="card-icon">
                {item.icon}
              </div>
              <div className="card-content">
                <div className="card-meta">
                  <span>{item.date}</span>
                  <span>-</span>
                  <span>{item.room}</span>
                </div>
                <h3 className="card-title">{item.subject} - {item.time}</h3>
              </div>
              <button className="card-menu">
                <span className="menu-dot"></span>
                <span className="menu-dot"></span>
                <span className="menu-dot"></span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ClassSchedule;